import { keysToCamelCase, removeUndefinedValues } from '../../../utils/object';
import { convertSSToMMSS } from '../../../utils/time';

import transcodingStatuses from '../../../constants/transcoding-statuses';
import videoSources from '../../../constants/video-sources';
import freeDealInfo from '../../../constants/free-deal-info';


export default function parseVideo(videoData) {

  if (!videoData) {
    return null;
  }

  videoData = keysToCamelCase(videoData);

  const {
    width,
    height,
    description,
    authorName: publisher,
    title,
    duration: durationSec,
  } = videoData;

  let {
    videoId: externalId,
    thumbnailUrl: coverUrl,
  } = videoData;

  externalId = String(externalId);
  coverUrl = coverUrl
    .replace(/^https?:/, '')
    .replace(/(_\d+(x\d+)?)?\.\w+$/, '.jpg');

  const mediaExternUrl = `//player.vimeo.com/video/${externalId}`;

  const durationStr = convertSSToMMSS(durationSec);

  return removeUndefinedValues({
    externalId,
    coverUrl,
    width,
    height,
    description,
    publisher,
    title,
    mediaExternUrl,
    mediaStatus: transcodingStatuses.READY,
    dealInfo: freeDealInfo,
    durationSec,
    durationStr,
    videoSource: videoSources.VIMEO,
  });

}



// WEBPACK FOOTER //
// ./src/transport/adapters/vimeo/parsers/video.js